import { ArrowDown, ArrowUp, CornerDownLeft } from "lucide-react";

import { Button } from "../ui/button";

interface SearchNavigationProps {
  onNavigateUp: () => void;
  onNavigateDown: () => void;
  onSelect: () => void;
}

export function SearchNavigation({
  onNavigateUp,
  onNavigateDown,
  onSelect,
}: SearchNavigationProps) {
  return (
    <nav 
      className={`flex-shrink-0`}
      aria-label="Navegação dos resultados"
    >
      <div className="flex flex-wrap items-center justify-between gap-2 px-2 sm:px-4 py-2">
        <div className="flex gap-2 items-center">
          <Button
            variant="ghost"
            size="icon"
            className="p-1 sm:p-2"
            onClick={onNavigateUp}
            data-navigation-button
            aria-label="Navegar para o resultado anterior"
          >
            <ArrowUp className="w-3 h-3 sm:w-4 sm:h-4" />
            <span className="sr-only">Anterior</span>
          </Button>

          <Button
            variant="ghost"
            size="icon"
            className="p-1 sm:p-2"
            onClick={onNavigateDown}
            data-navigation-button
            aria-label="Navegar para o próximo resultado"
          >
            <ArrowDown className="w-3 h-3 sm:w-4 sm:h-4" />
            <span className="sr-only">Próximo</span>
          </Button>

          <span className={`text-xs sm:text-sm text-[var(--ai-search-text)]`}>
            Use para navegar
          </span>
        </div>

        <div className="flex gap-2 items-center">
          <Button
            variant="ghost"
            size="icon"
            className="p-1 sm:p-2"
            onClick={onSelect}
            data-navigation-button
            aria-label="Selecionar resultado atual"
          >
            <CornerDownLeft className="w-3 h-3 sm:w-4 sm:h-4" />
            <span className="sr-only">Selecionar</span>
          </Button>

          <span className={`text-xs sm:text-sm text-[var(--ai-search-text)]`}>
            Enter para selecionar
          </span>
        </div>
      </div>
    </nav>
  );
}
